import React from "react";
import { Flex, Text, CheckboxField } from "@aws-amplify/ui-react";

export default function ActiveTodoItem({ data, onChecked }) {
  return (
    <Flex direction={"column"} gap={1}>
      <CheckboxField
        onChange={onChecked.bind(this, data?.id)}
        label={`${data?.todoDescription} - ${data?.todoDueDate.split("-T-").pop()}`}
        name={data?.id}
        value="no"
      />
      <Text
        variation="tertiary"
        fontSize={12}
        children={`Due Date: ${data?.todoDueDate.split("-T-")[0]}`}
      />
    </Flex>
  );
}
